import { faCompress, faExpand } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'
import { fetchTrackingByCourseContentScorm } from 'store/Course/actions'
import Scorm from './Scorm'

import '../style.css'

const ViewScorm = (props) => {
  const { id } = useParams()

  const dispatch = useDispatch()
  return (
    <div
      className={`tl-employee-content-wrapper h-100 scrollbar ${
        props.isFullscreen ? ' fullscreen' : ''
      }`}
    >
      {(() => {
        if (!id) {
          return null
        }

        const content = props.content.filter((item) => item.id == parseInt(id))

        if (!content.length) {
          return null
        }

        const user = {
          id: props.user.id,
          name: props.user.first_name + ' ' + props.user.last_name,
        }
        return (
          <Scorm
            onScormProgress={props.onScormProgress}
            suspendData={props.suspendData}
            courseId={props.course_id}
            user={user}
            {...content[0].content[0]}
            fetchTracking={props.fetchTracking}
            fetchTrackingByCourseContentScorm={(courseId, contentId) =>
              dispatch(fetchTrackingByCourseContentScorm(courseId, contentId))
            }
            finishContent={props.finishContent}
            setSuspendDataOnMount={props.setSuspendDataOnMount}
            resetSuspendDataOnMount={props.resetSuspendDataOnMount}
            isFullscreen={props.isFullscreen}
            params={id}
          />
        )
      })()}
      <button
        title={props.isFullscreen ? 'Exit fullscreen' : 'Full screen'}
        onClick={props.makeFullscreen}
        className='btn-fullscreen'
      >
        {props.isFullscreen ? (
          <FontAwesomeIcon icon={faCompress} />
        ) : (
          <FontAwesomeIcon icon={faExpand} />
        )}
      </button>
    </div>
  )
}

export default ViewScorm
